import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router'

import { getValidationRules } from '../validation/validation'
import LicenseFormComponent from '../components/profile/License/LicenseFormComponent';

export default withRouter(reduxForm({
    form: 'license',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate: getValidationRules([
        'name',
        'platform',
        'category',
        'description',
        'redirectUrl',
    ]),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(LicenseFormComponent));



// WEBPACK FOOTER //
// ./src/containers/LicenseFormContainer.js